import React from 'react';
import PropTypes from 'prop-types';

// Components
import OverlaySpinner from 'dibs-overlay-spinner';
import styles from './styles/OverlaySpinner.scss';

const Loading = ({ isLoadingFullPage, partialPageLoading }) => {
    if (isLoadingFullPage) {
        return (
            <div className={styles.overlay}>
                <OverlaySpinner
                    additionalWrapperClasses={`${styles.additionalWrapperClasses} ${styles.full}`}
                    additionalOverlayClasses={styles.additionalOverlayClasses}
                    additionalSpinnerClasses={`${styles.additionalSpinnerClasses} ${styles.over}`}
                    position="isFixed"
                />
            </div>
        );
    } else if (partialPageLoading) {
        return (
            <OverlaySpinner
                additionalWrapperClasses={styles.additionalWrapperClasses}
                additionalOverlayClasses={styles.additionalOverlayClasses}
                additionalSpinnerClasses={`${styles.additionalSpinnerClasses} ${styles.under}`}
                position="isRelative"
            />
        );
    }
    if (typeof document !== 'undefined') {
        document.body.style.overflowY = 'visible';
    }
    return null;
};

Loading.propTypes = {
    isLoadingFullPage: PropTypes.bool,
    partialPageLoading: PropTypes.bool,
};

export default Loading;
